if (!customElements.get("td-product-gallery")) {
  class TdProductGallery extends HTMLElement {
    constructor() {
      super();
      this.videos = [];
      this.currentVideo = null;
    }

    connectedCallback() {
      this.initVideos();
      this.setupEventListeners();
      this.setupSwiperListeners();
    }

    initVideos() {
      // Find all video elements in the gallery
      this.videos = this.querySelectorAll('.td-product__video');
      
      this.videos.forEach(video => {
        // Pause other videos when one starts playing
        video.addEventListener('play', () => {
          this.pauseOtherVideos(video);
          this.updateVideoState(video, true);
        });
        
        // Handle video pausing
        video.addEventListener('pause', () => {
          this.updateVideoState(video, false);
        });
        
        // Handle video ending
        video.addEventListener('ended', () => {
          this.updateVideoState(video, false);
        });
        
        // Handle video loading
        video.addEventListener('loadeddata', () => {
          video.style.opacity = '1';
        });
      });
    }

    setupEventListeners() {
      // Handle video thumbnail clicks
      const videoThumbnails = this.querySelectorAll('.td-product__video-thumbnail');
      
      videoThumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', (e) => {
          e.preventDefault();
          const mediaId = thumbnail.closest('[data-media-id]').dataset.mediaId;
          this.switchToVideo(mediaId);
        });
      });

      // Handle video play overlay clicks
      const videoPlayOverlays = this.querySelectorAll('.td-product__video-play-overlay');
      
      videoPlayOverlays.forEach(overlay => {
        overlay.addEventListener('click', (e) => {
          e.preventDefault();
          const video = overlay.closest('.td-product__media__video').querySelector('.td-product__video');
          if (video) {
            if (video.paused) {
              video.play().catch(error => {
                console.log('Video play failed:', error);
              });
            } else {
              video.pause();
            }
          }
        });
      });

      // Handle video clicks (for play/pause functionality)
      const videos = this.querySelectorAll('.td-product__video');
      videos.forEach(video => {
        video.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (video.paused) {
            video.play().catch(error => {
              console.log('Video play failed:', error);
            });
          } else {
            video.pause();
          }
        });
      });

      // Handle video container clicks
      const videoContainers = this.querySelectorAll('.td-product__media__video');
      videoContainers.forEach(container => {
        container.addEventListener('click', (e) => {
          // Only handle clicks if they're not on the overlay
          if (!e.target.closest('.td-product__video-play-overlay')) {
            const video = container.querySelector('.td-product__video');
            if (video) {
              if (video.paused) {
                video.play().catch(error => {
                  console.log('Video play failed:', error);
                });
              } else {
                video.pause();
              }
            }
          }
        });
      });

      // Handle slide changes to pause videos
      this.addEventListener('swiper-slide-change', () => {
        this.pauseAllVideos();
      });

      // Handle scroll events to pause videos
      let scrollTimeout;
      window.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          this.pauseAllVideos();
        }, 100);
      }, { passive: true });

      // Handle visibility change to pause videos
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.pauseAllVideos();
        }
      });
    }

    setupSwiperListeners() {
      // Wait for swiper to be initialized
      const checkSwiper = () => {
        const swiperContainer = this.querySelector('[data-swiper]');
        if (swiperContainer && swiperContainer.swiper) {
          swiperContainer.swiper.on('slideChange', () => {
            this.pauseAllVideos();
          });
        } else {
          // If swiper not ready yet, try again in a bit
          setTimeout(checkSwiper, 100);
        }
      };
      
      checkSwiper();

      // Also listen for custom swiper events
      this.addEventListener('swiper-slide-change', () => {
        this.pauseAllVideos();
      });

      // Listen for any swiper-related events
      document.addEventListener('swiper-slide-change', () => {
        this.pauseAllVideos();
      });

      // Listen for the custom event that might be emitted by the swiper component
      document.addEventListener('product-media-changed', () => {
        this.pauseAllVideos();
      });
    }

    switchToVideo(mediaId) {
      // Find the video element with this media ID
      const videoContainer = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (videoContainer) {
        const video = videoContainer.querySelector('.td-product__video');
        if (video) {
          // Pause current video if any
          if (this.currentVideo && this.currentVideo !== video) {
            this.currentVideo.pause();
          }
          
          // Play the new video
          video.play().catch(error => {
            console.log('Video play failed:', error);
          });
          
          this.currentVideo = video;
        }
      }
    }

    pauseOtherVideos(currentVideo) {
      this.videos.forEach(video => {
        if (video !== currentVideo && !video.paused) {
          video.pause();
        }
      });
    }

    // Method to pause all videos (useful for when user navigates away)
    pauseAllVideos() {
      this.videos.forEach(video => {
        if (!video.paused) {
          video.pause();
        }
      });
      this.currentVideo = null;
    }

    updateVideoState(video, isPlaying) {
      const videoContainer = video.closest('.td-product__media__video');
      if (videoContainer) {
        if (isPlaying) {
          videoContainer.classList.add('playing');
        } else {
          videoContainer.classList.remove('playing');
        }
      }
    }
  }

  customElements.define("td-product-gallery", TdProductGallery);
}

// Handle page visibility changes to pause videos when tab is not visible
document.addEventListener('visibilitychange', () => {
  if (document.hidden) {
    const galleries = document.querySelectorAll('td-product-gallery');
    galleries.forEach(gallery => {
      if (gallery.pauseAllVideos) {
        gallery.pauseAllVideos();
      }
    });
  }
}); 